import { connect } from 'react-redux';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import get from 'lodash/get';
import cx from 'classnames';
import shippingTypeToPrismicKey from 'src/common/utils/shipping-type-to-prismic-key';
import { date } from 'src/common/utils/date-time-formatter';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import { getShippingDates } from '../Shipping/duck';
import { withModel } from '../../data-providers/model';
import PromoBanners from './PromoBanners';

const getPromoMessage = (banner, props) => {
  let text = banner.text || '';
  if (text.includes('%{code}')) {
    const className = cx('highlight', { [`color-${banner.promoCodeTextColour}`]: banner.promoCodeTextColour });
    const style = `background-color: ${banner.promoCodeBackground}`;
    text = replaceTextWithValues(text, {
      code: `<span class="${className}" style="${style}">${banner.promoCode}</span>`
    });
  }

  if (text.includes('%{lod_')) {
    let shippingDates = props.model.eagleModel.shippingEstimates;
    // eagleModel.shippingEstimates are the estimated dates, ignoring the card content.
    // props.shippingDates - are the estimated dates based on the cart content.
    if (get(props, 'shippingDates.length', 0) > 0) {
      shippingDates = props.shippingDates;
    }

    const shippingValues = shippingDates.reduce((values, shipping) => {
      const key = shippingTypeToPrismicKey(shipping.type);

      values[`lod_${key}`] = date(shipping.xmas_cutoff, props.model.countryModel, {
        weekday: 'long',
        month: 'short',
        day: 'numeric'
      });

      return values;
    }, {});

    text = replaceTextWithValues(text, shippingValues);
  }

  return text;
};

const enhance = compose(
  connect(state => ({
    shippingDates: getShippingDates(state),
  })),
  withModel,
  mapProps(props => {
    const defaultPromoBanner = props.model.prismicPromoBannerModel;
    const prismicGeneralBanners = get(props, 'model.prismicGlobalContentModel.general.banners', []);
    const generalBanners = prismicGeneralBanners.map(item => item.banner).filter(banner => banner.text);
    const banners = generalBanners.length > 0 ? generalBanners : [defaultPromoBanner];
    const isRedirected = props.location.pathname.includes('personalized-products') && props.location.search.includes('product-added');
    const addedProductBannerIndex = generalBanners.findIndex(banner => banner.slug === 'product-added-banner');

    // showing Added Product Banner if query params "product-added" exists
    if (!isRedirected && addedProductBannerIndex !== -1) {
      banners.splice(addedProductBannerIndex, 1);
    }
    return {
      banners: banners.map(item => ({
        ...item,
        text: getPromoMessage(item, props),
      })),
    };
  }),
);

export default enhance(PromoBanners);



// WEBPACK FOOTER //
// ./src/client/js/view/components/PromoBanners/index.js